import {HTTP_METHODS} from '../httpMethods'
import {toSafePathSegment} from '@/utils/security/pathSafety'

export const PRODUCT_CATALOG_CONFIG = {
  GET_CATALOG: {
    endPoint: 'admin/catalog',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
    headers: {
      scope: 'pepsi',
    },
  },

  DELETE_BRNAD_IMAGE: brandId => ({
    endPoint: `entity/displaybrand/${toSafePathSegment(brandId)}/image`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.DELETE,
    headers: {
      scope: 'pepsi',
    },
  }),

  UPDATE_CATALOG: {
    endPoint: 'admin/display-config',
    method: HTTP_METHODS.PUT,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
}
